import React, { useEffect } from 'react';
import {
    Box,
    Collapse,
    TableRow,
    TableCell,
    IconButton,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SMSEchoBuilder from './smsEchoBuilder';
import { ECHO_TYPE } from '../../../../../constants';

function SMSEchoRow(props) {
    const { id, name, message, duration, type } = props;
    const [open, setOpen] = React.useState(false);
    return (
        <>
            <TableRow className="echo-row" key={'echo-row'+id}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>{id}</TableCell>
                <TableCell>{name}</TableCell>
                <TableCell>{duration}</TableCell>
                <TableCell>{ECHO_TYPE[type]}</TableCell>
            </TableRow>
            <TableRow key={'echo-row-details'+id}>
                <TableCell className="py-0" colSpan={5}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <SMSEchoBuilder
                                id={id}
                                name={name}
                                message={message}
                                duration={duration}
                                type={type}
                                handleEchoRowState={() => setOpen(!open)}
                            />
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

export default SMSEchoRow;
